import React from 'react'

export const NotFound = () => {
    return (
        <div className='app-container'>
            <div style={{textAlign: 'center', margin: '5rem 0'}} className='register-form-container-100'>
                <h1 style={{margin: '1rem 0 0 0', padding: 0, fontWeight: 'bold', fontSize: '3rem'}}>¡Lo sentimos!</h1>
                <h2 style={{margin: '0', padding: 0, fontWeight: 200, fontSize: '3rem'}}>No encontramos la página que buscas</h2>
            </div>
        </div>
    )
}
